export default __webpack_public_path__ + "static/media/proto-chain-schema.542199a0.png";